module.exports = __webpack_public_path__ + "static/media/lamina22mapa.6351321a.png";